import{classesData}from"./map.js";












export const validateSubclass=(ErrorClass)=>{
if(classesData.has(ErrorClass)){
return
}

const{name}=ErrorClass;
const{name:parentName}=Object.getPrototypeOf(ErrorClass);
throw new Error(
`"new ${name}()" must not be directly called.
This error class should be created like this instead:
  export const ${name} = ${parentName}.subclass('${name}')`
)
};